module.exports = "/_next/static/chunks/fonts/HindMadurai-Bold-ed49b6379fa466f11817a316b36ad9ea.woff";